import { get_favourite_product_list } from "../../api/category_product/Category_Product";

import {
    FETCH_WISHLIST_REQUEST,
    FETCH_WISHLIST_SUCCESS,
    FETCH_WISHLIST_FAILURE
} from "../types";

export const fetchWishlist = () => async (dispatch) => {
    dispatch({ type: FETCH_WISHLIST_REQUEST });
    try {
        const token = localStorage.getItem("user_token");
        if (!token) throw new Error("Token not found");

        const response = await get_favourite_product_list({ Authorization: `Bearer ${token}` });

        const { favourite } = response?.data?.data;

        if (response?.data?.status == 200) {

            dispatch({
                type: FETCH_WISHLIST_SUCCESS,
                payload: favourite
            });

        } else {
            dispatch({
                type: FETCH_WISHLIST_FAILURE,
                payload: "Failed to fetch wishlist"
            });
        }
    } catch (error) {

        dispatch({
            type: FETCH_WISHLIST_FAILURE,
            payload: error.message
        });
        return { unauthorized: true };

    }
};
